import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from "react-table";
import request from '../../utils/agent';
import Loader from 'components/Loader';
import './UserWhereToBuy.scss'


export default class UserWhereToBuy extends React.Component {
    constructor (props) {
        super(props);

        this.state = {
            locD: [],
            locLoaded: false,
            searchDistributor:"",
        }
    }

    componentDidMount() {
        this.getLocationsData();
    }

    getLocationsData = () => {
        request.get('/api/companies/locations')
            .then(resp => {
                //console.log('response', resp.body.distributor_locations);
                this.setState({
                    locD: resp.body.distributor_locations,
                    locLoaded: true
                });
            });
    };



    render() {

        //console.log('locD', this.state.locD);
        //console.log('loaded', this.state.locLoaded);

        let locations = this.state.locD;

        if(this.state.searchDistributor) {
            locations = locations.filter(row => {
                return row.company_name.includes(this.state.searchDistributor) || row.address.includes(this.state.searchDistributor) || row.city.includes(this.state.searchDistributor)
            })
        }

        const columns = [
            {
                Header: 'Name',
                id: 'company_name',
                accessor: 'company_name',
                className: 'react--tb--styles',
            },
            {
                Header: 'Website',
                id: 'website',
                accessor: 'website',
                className: 'react--tb--styles',
            },
            {
                Header: 'Address',
                id: 'address',
                accessor: loc => <div><div>{loc.address}</div><div>{loc.city}, {loc.stateprovince} {loc.postal}</div></div>,
                className: 'react--tb--styles',
            },
            {
                Header: 'Phone',
                id: 'phone',
                accessor: 'phone',
                className: 'react--tb--styles',
            }

        ];
        const pageOpts = [10, 25, 50, 100];


        return(
            <section >
                <h1>Where to Buy</h1>
                {this.state.locLoaded === true ?
                    <div className='users-table-hoalder'>
                        <h3 className='table-title'>Available Distributors</h3>
                        <div className='tb-search-holder'>
                            <div className='search--cont'>
                                Search: <input
                                className='tb-search-input'
                                value={this.state.searchDistributor}
                                onChange={e => this.setState({searchDistributor: e.target.value})}
                            />
                            </div>
                            <ReactTable
                                columns={columns}
                                data={locations}
                                pageSizeOptions={pageOpts}
                                defaultPageSize={10}
                            />
                        </div>
                    </div>:
                    <Loader/>
                }
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/routes/UserWhereToBuy/index.js